import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import logo from '../../assets/img/reactlogo.png';

function Register() {
  const [errors, setErrors] = useState(false);
  const navigate = useNavigate();
  const [otpField, setOtpField] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData();
    let errorData = {};
    let jsonData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        else {
          //jsonData[item.name] = item.value;
          if (item.type === 'file') {
            Array.from(item.files).forEach((file) => {
              formData.append(item.name, file);
            });
          } else {
            formData.append(item.name, item.value);
          }
        }
      }
    });
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    }
    else {
      try {
        if (!(e.target.otp)) {
          const response = await axios.post('/user/check/mobile/newweb', { mobile: e.target.mobile.value });
          const { status, message } = response.data;
          toast(message);
          if (status) {
            setOtpField(true);
          }
        }
        else {
          formData.append("otp", e.target.otp.value);
          const response = await axios.post('/user/new/signup', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          const { status, message } = response.data;
          if (status) {
            toast(message);
            navigate('/login');
          }
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          if (error?.response?.data?.message != "OTP is wrong.") {
            setOtpField(false);
          }
          toast(error.response.data.message);
        }
      }
    }
  };
  function addSpaceBetweenCases(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
  };
  const deleteError = (e) => {
    const errorKey = e.target.name;
    if (errorKey) {
      const updatedErrors = { ...errors };
      delete updatedErrors[errorKey];
      setErrors(updatedErrors);
    }
  };
  return (
    <div class="col-lg-6 d-flex align-items-center justify-content-center">
      <div class="auth-form-transparent text-left p-3 register">
        <div class="brand-logo">
          <img src={logo} alt="logo" />
        </div>
        <h4>New here?</h4>
        <h6 class="font-weight-light">Join us today! It takes only few steps</h6>
        <form class="pt-3" onSubmit={handleSubmit}>
          <div class="form-group">
            <label>Name</label>
            <div class="input-group">
              <div class="input-group-prepend bg-transparent">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="ti-user text-primary"></i>
                </span>
              </div>
              <input type="text" class="form-control form-control-lg border-left-0" name="name" placeholder="name" onChange={deleteError} requiredField="true" />
              <span className="error">{errors && errors?.name}</span>
            </div>
          </div>
          <div class="form-group">
            <label>Gender</label>
            <div class="input-group">
              <select class="form-control form-control-lg" id="exampleFormControlSelect2" name="gender" onChange={deleteError} requiredField="true">
                <option value="">--Select--</option>
                <option value="Male">Male</option>
                <option vale="Female">Female</option>
              </select>
              <span className="error">{errors && errors?.gender}</span>
            </div>
          </div>
          <div class="form-group">
            <label>Date Of Birth</label>
            <div class="input-group">
              <div class="input-group-prepend bg-transparent">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="ti-user text-primary"></i>
                </span>
              </div>
              <input type="date" class="form-control form-control-lg border-left-0" name="dob" onChange={deleteError} requiredField="true" />
              <span className="error">{errors && errors?.dob}</span>
            </div>
          </div>
          <div class="form-group">
            <label>Email</label>
            <div class="input-group">
              <div class="input-group-prepend bg-transparent">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="ti-email text-primary"></i>
                </span>
              </div>
              <input type="email" class="form-control form-control-lg border-left-0" name="email" placeholder="Email" onChange={deleteError} requiredField="true" />
              <span className="error">{errors && errors?.email}</span>
            </div>
          </div>
          <div class="form-group">
            <label>Phone Number</label>
            <div class="input-group">
              <div class="input-group-prepend bg-transparent">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="ti-user text-primary"></i>
                </span>
              </div>
              <input type="number" class="form-control form-control-lg border-left-0" name="mobile" placeholder="Phone Number" onChange={deleteError} requiredField="true" />
              <span className="error">{errors && errors?.mobile}</span>
            </div>
          </div>
          <div class="form-group">
            <label>Password</label>
            <div class="input-group">
              <div class="input-group-prepend bg-transparent">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="ti-lock text-primary"></i>
                </span>
              </div>
              <input type="password" class="form-control form-control-lg border-left-0" id="exampleInputPassword" name="password" placeholder="Password" onChange={deleteError} requiredField="true" />
              <span className="error">{errors && errors?.password}</span>
            </div>
          </div>
          {/* <div class="form-group">
            <label>Aadhaar Card Number</label>
            <div class="input-group">
              <div class="input-group-prepend bg-transparent">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="ti-user text-primary"></i>
                </span>
              </div>
              <input type="number" class="form-control form-control-lg border-left-0" name="aadharCardNumber" placeholder="Aadhaar Card Number" onChange={deleteError} requiredField="true" />
              <span className="error">{errors && errors?.aadharCardNumber}</span>
            </div>
          </div> */}
          <div class="form-group">
            <label>Upload Aadhaar Card (Front)</label>
            <div class="input-group">
              <div class="input-group-prepend bg-transparent">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="ti-user text-primary"></i>
                </span>
              </div>
              <input type="file" class="form-control form-control-lg border-left-0" name="aadhar_card_front" onChange={deleteError} requiredField="true" />
              <span className="error">{errors && errors?.aadhar_card_front}</span>
            </div>
          </div>
          <div class="form-group">
            <label>Upload Aadhaar Card (Back)</label>
            <div class="input-group">
              <div class="input-group-prepend bg-transparent">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="ti-user text-primary"></i>
                </span>
              </div>
              <input type="file" class="form-control form-control-lg border-left-0" name="aadhar_card_back" onChange={deleteError} requiredField="true" />
              <span className="error">{errors && errors?.aadhar_card_back}</span>
            </div>
          </div>
          {/* <div class="form-group">
            <label>Pan Card</label>
            <div class="input-group">
              <div class="input-group-prepend bg-transparent">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="ti-user text-primary"></i>
                </span>
              </div>
              <input type="text" class="form-control form-control-lg border-left-0" name="panCard" placeholder="PAN Card" onChange={deleteError} requiredField="true" />
              <span className="error">{errors && errors?.panCard}</span>
            </div>
          </div> */}
          <div class="form-group">
            <label>Upload Origional Pan Card</label>
            <div class="input-group">
              <div class="input-group-prepend bg-transparent">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="ti-user text-primary"></i>
                </span>
              </div>
              <input type="file" class="form-control form-control-lg border-left-0" name="pan_card_front" onChange={deleteError} requiredField="true" />
              <span className="error">{errors && errors?.pan_card_front}</span>
            </div>
          </div>
          <div class="form-group">
            <label>Profile Picture</label>
            <div class="input-group">
              <div class="input-group-prepend bg-transparent">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="ti-user text-primary"></i>
                </span>
              </div>
              <input type="file" class="form-control form-control-lg border-left-0" name="image" onChange={deleteError} requiredField="true" />
              <span className="error">{errors && errors?.image}</span>
            </div>
          </div>
          {
            otpField && (
              <div class="form-group">
                <label>OTP</label>
                <div class="input-group">
                  <div class="input-group-prepend bg-transparent">
                    <span class="input-group-text bg-transparent border-right-0">
                      <i class="ti-user text-primary"></i>
                    </span>
                  </div>
                  <input type="number" class="form-control form-control-lg border-left-0" name="otp" placeholder="OTP" onChange={deleteError} requiredField="true" />
                  <span className="error">{errors && errors?.otp}</span>
                </div>
              </div>
            )
          }
          {/* <div class="mb-4">
            <div class="form-check">
              <label class="form-check-label text-muted">
                <input type="checkbox" class="form-check-input" onChange={deleteError} requiredField="true" />
                I agree to all Terms & Conditions
              </label>
            </div>
          </div> */}
          <div class="mt-3">
            <button type="submit" class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn">SIGN UP</button>
          </div>
          <div class="text-center mt-4 font-weight-light">
            Already have an account? <Link to="/login" class="text-primary">Login</Link>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Register;
